const isMatchMobile = () => window.matchMedia('(max-width: 767px)').matches;

export default isMatchMobile;
